import React, { Component, createRef } from 'react'
import axios from 'axios';
import MyLoader from '../Spinner/MyLoader';
import SessionManager from '../Utils/SessionManager';
import { BrowserRouter as Router, Link, Redirect, Route } from 'react-router-dom';
import '../css/Admin_css/admin-customize.css';
import myToast from '../Utils/MyToast';
import icons_school_bus from '../resources/icons/icons_school_bus.jpeg'
export default class TransportVehicles extends Component {
  constructor(props) {
    super(props)
    this.slt_board = createRef();
    this.slt_medium = createRef();

    const token = localStorage.getItem("token");
    let loggedIn = true;
    if (token == null) {
      loggedIn = false;
    }

    this.state = {
      isOpenAddSection: false,
      isOpenAddNewClass: false,
      loggedIn: true,
      Loading: false,
      CLASS_ID: '',
      SECTION_ID: '',
      mClassData: [],
      mClassBoard: [],
      mClassMedium: [],
      mFilteredClassSectionList: []
    }
    this.HandleCloseAddSection = this.HandleCloseAddSection.bind(this);
    this.HandleCloseAddNewClass = this.HandleCloseAddNewClass.bind(this);

  }


  componentDidMount() {

    this.getClass();
  }


  AddSection = () => {

    //alert("Add Section");
    this.HandleCloseAddSection();

  }
  AddNewClass = () => {

    // alert("Add new class");
    this.HandleCloseAddNewClass();

  }
  HandleCloseAddSection() {

    this.setState({
      isOpenAddSection: !this.state.isOpenAddSection
    })
  }
  HandleCloseAddNewClass() {

    this.setState({
      isOpenAddNewClass: !this.state.isOpenAddNewClass
    })
  }
  onBoardChange = (event) => {
    //this.setState({ value: event.target.value });
    //let board_id=event.target.selectedOptions[0].getAttribute('board_id');

    this.getClassList();


  };
  onMediumChange = (event) => {
    this.getClassList();
  }
  getClassList() {

    let board_id = this.slt_board.current.selectedOptions[0].getAttribute('board_id');
    let medium_id = this.slt_medium.current.selectedOptions[0].getAttribute('medium_id');
    //alert(board_id);
    //alert(medium_id);
    //filtering class of selected board and medium
    var mFilteredClassList = [];
    this.state.mFilteredClassSectionList = [];
    for (var i = 0; i < this.state.mClassData.length; i++) {
      let item = this.state.mClassData[i];
      if (item.board_id === board_id && item.medium_id === medium_id) {

        mFilteredClassList.push(item);

      }
    }
    //console.log("ClassList>>>>>>",mFilteredClassList); 
    //getting section of classes
    for (var i = 0; i < mFilteredClassList.length; i++) {
      let item = mFilteredClassList[i];
      let SECTION = item.section;
      if (SECTION === "No") {

        this.state.mFilteredClassSectionList.push(item);
      }
      else {

        var tempSection = [];
        tempSection = item.section;
        for (var j = 0; j < tempSection.length; j++) {
          let item2 = tempSection[j];
          item2["board_id"] = board_id;
          item2["board_name"] = item.board_name;
          item2["medium_id"] = medium_id;
          item2["medium_name"] = item.medium_name;
          //console.log("item2>>>>>>",item2);                
          this.state.mFilteredClassSectionList.push(item2);

        }
      }

    }
    this.setState({

    })
  }


  getClass() {

    this.setState({
      Loading: true
    })
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    var mSession = SessionManager.getCurrentSession();
    const SESSION_ID = mSession[0].session_id;
    //alert(SESSION_ID);

    const API_NAME = 'getClassWithStudentCount.php'
    URL = process.env.REACT_APP_SERVER_NAME + process.env.REACT_APP_TARGET_DIR + API_NAME
    //console.log("URL>>>>>" + URL)
    // var params = new URLSearchParams();
    //  params.append('school_code', SCHOOL_CODE);

    axios.get(URL, {
      params: {
        school_code: SCHOOL_CODE,
        session_id: SESSION_ID
      }
    }).then(res => res.data)
      .then((response) => {

        this.setState({
          Loading: false
        })
        //console.log("Response2>>>>>" + response);
        let api_status = response.api_status;
        // alert(api_status);

        if (api_status == "OK") {

          this.setState({
            mClassData: response.data.class,
            mClassBoard: response.data.board,
            mClassMedium: response.data.medium
          })
          this.getClassList();
          //console.log("response>>>>>"+this.state.mClassData);
        }
        else {
          let api_remark = response.api_remark;
          myToast.notify_warning(api_remark);
        }

        //console.log("response>>>>>"+api_status)
      }).catch((error) => {
        this.setState({
          Loading: false
        })
        console.log("error>>>>>" + error);
      });
  }


  render() {
    if (this.state.loggedIn == false) {
      return <Redirect to='/Login' />;
    }
    if (this.state.Loading) {
      return <MyLoader />
    }
    else {
      return (

        <div className="content">
          <div className="content-header">
            <div className="leftside-content-header">
              <ul className="breadcrumbs">
                <li><i className="fa fa-home" aria-hidden="true" /><a href="#">Transport Vehicles</a></li>
              </ul>
            </div>

          </div>

          <div className="animated fadeInUpn bg_page_white_rounded box_shadow" style={{ '--mMargin': '50px' }}>
            <h4 className='staffcenter'>Vehicles List</h4>
            <div className="row class-li">

              <div className="col-sm-6 col-md-6 padding_5 ">

                <div className="row class-list-box bb-r-c height-130 bg_card_burnt_orange_outline">
                  <div className="">
                    <div className="profil-im-img mar_top1" style={{ background: 'white', borderRadius: '29%', width: '110px', height: '110px', padding: '0px' }}>
                      <div><img src={icons_school_bus} alt="" style={{ width: '150%' }} /></div>
                    </div>
                  </div>
                  <div className="col-sm-9 col-md-9 text_burnt">
                    <h3 className=''> Jiyanpur To Azamgarh  </h3>
                    <hr />
                    <p><strong> Vehicle Name: </strong> <span>Innova</span> &nbsp; <strong> Vehicle type: </strong> <span>AC</span> </p>
                    <p> <strong> Vehicle Number: </strong> <span>UP50AY6667</span> </p>

                  </div>
                </div>

              </div>

              <div className="col-sm-6 col-md-6 padding_5 ">

                <div className="row class-list-box bb-r-c height-130 bg_card_burnt_orange_outline">
                  <div className="">
                    <div className="profil-im-img mar_top1" style={{ background: 'white', borderRadius: '29%', width: '110px', height: '110px', padding: '0px' }}>
                      <div><img src={icons_school_bus} alt="" style={{ width: '150%' }} /></div>
                    </div>
                  </div>
                  <div className="col-sm-9 col-md-9 text_burnt">
                    <h3 className=''> Jiyanpur To manikadih  </h3>
                    <hr />
                    <p><strong> Vehicle Name: </strong> <span>Innova</span> &nbsp; <strong> Vehicle type: </strong> <span>AC</span> </p>
                    <p> <strong> Vehicle Number: </strong> <span>UP50AY6667</span> </p>

                  </div>
                </div>

              </div>

            </div>

            <div className=" row">
              <div className="col-md-12 padding_0">
                <center>
                  <Link to={{ pathname: '/AdminMain/StaffRegistration' }}>
                    <button className="btn btn-primary" onClick={this.regSubmit} style={{ margin: '2% 0px', fontSize: '18px', width: '100%' }}> Add Vehicles </button>
                  </Link>
                </center>
              </div>
            </div>
          </div>


        </div>

      )
    }
  }
}
